exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formLabel[data-v-ce428756]{font-weight:600;display:-webkit-box;display:-ms-flexbox;display:flex;line-height:1.1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:8px}.formLabel .label[data-v-ce428756]{color:#4f4f4f;font-size:13px}.formLabel .required[data-v-ce428756]{font-size:12px;margin-left:3px;color:#ff4438}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce428756","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/FormLabel.vue
// module id = 9IKR
// module chunks = 0